import React, { useState } from 'react';
import { Loader2Icon, PackageSearchIcon } from 'lucide-react';
import { PageHeader } from '../../components/ui/PageHeader';
import { FormField, inputClasses } from '../../components/ui/FormField';
import { buttonClasses } from '../../utils/buttonStyles';
type Status = 'idle' | 'loading' | 'unavailable';
export function OrderTracking() {
  const [order, setOrder] = useState('');
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [status, setStatus] = useState<Status>('idle');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const next: Record<string, string> = {};
    if (!order.trim()) next.order = 'Enter your order number.';
    if (!/^\S+@\S+\.\S+$/.test(email)) next.email = 'Enter the email used for your order.';
    setErrors(next);
    if (Object.keys(next).length) return;
    setStatus('loading');
    window.setTimeout(() => setStatus('unavailable'), 700);
  };
  return <>
      <PageHeader title="Order Tracking" lead="Enter your order number and email to see the latest status of your shipment." data-id="element-1349" data-mp="3h1k8sbe6wjos" />
      <div className="mx-auto max-w-site px-5 py-16 md:px-8 md:py-24" data-id="element-1350" data-mp="3c2quigr2wonk">
        <form noValidate onSubmit={submit} className="grid max-w-3xl gap-6 md:grid-cols-[1fr_1fr_auto] md:items-end" data-id="element-1351" data-mp="3q39ztg45tgm1">
          <FormField id="ot-order" label="Order number" error={errors.order} data-id="element-1352" data-mp="3l58gqv6qhhak">
            <input className={inputClasses} value={order} onChange={e => setOrder(e.target.value)} placeholder="#1001" data-id="element-1353" data-mp="2xdkx8ybsx8ib" />
          </FormField>
          <FormField id="ot-email" label="Email" error={errors.email} data-id="element-1354" data-mp="2taodh4aiz6cs">
            <input type="email" className={inputClasses} value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" data-id="element-1355" data-mp="374xrtxozics1" />
          </FormField>
          <button type="submit" disabled={status === 'loading'} className={buttonClasses('primary')} data-id="element-1356" data-mp="2enlfyxm7cxpg">
            {status === 'loading' && <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-1357" data-mp="29nqq8xe5ye5z" />}
            Track order
          </button>
        </form>

        {status === 'unavailable' && <div role="status" className="mt-10 flex max-w-3xl gap-4 rounded-2xl border border-ice/25 bg-ice/[0.05] p-6" data-id="element-1358" data-mp="ikqej5k50ol4">
            <PackageSearchIcon className="h-6 w-6 shrink-0 text-ice" aria-hidden data-id="element-1359" data-mp="nax4p9uash5h" />
            <div data-id="element-1360" data-mp="saa0ik35cyk7">
              <h2 className="font-semibold text-white" data-id="element-1361" data-mp="sat754nck0ix">Check your shipping confirmation</h2>
              <p className="mt-1 text-sm text-titanium" data-id="element-1362" data-mp="3qsoz0uvwpd6u">
                Use the tracking link in your shipping confirmation email, or contact support and we'll look up your order.
              </p>
            </div>
          </div>}
      </div>
    </>;
}